import { Button, Callout, Modal, Progress } from "@/ui";
import CcpaDeleteSummary from "./CcpaDeleteSummary";
import styles from "./CcpaDeleteModal.module.scss";

const titleByStep = (step, result) => {
    if (step === "loading") {
        return "Deleting customer data";
    }

    if (step === "result") {
        return result?.success
            ? "Customer data deleted"
            : "Failed to delete customer data";
    }

    return "Permanently delete customer data?";
};

const CcpaDeleteModal = ({
    open,
    step,
    customer: _customer,
    result,
    onConfirm,
    onClose,
}) => {
    const isLoading = step === "loading";
    const isResult = step === "result";

    const handleOpenChange = nextOpen => {
        if (!nextOpen && !isLoading) {
            onClose();
        }
    };

    return (
        <Modal
            description={
                step === "confirm"
                    ? "This action permanently deletes this customer's data from the store and cannot be undone."
                    : isLoading
                    ? "Please wait while we delete this customer's data..."
                    : undefined
            }
            footer={
                isLoading ? undefined : (
                    <div className={styles.footer}>
                        {step === "confirm" ? (
                            <>
                                <Button
                                    onClick={onConfirm}
                                    type="button"
                                    variant="primary"
                                >
                                    Confirm Delete
                                </Button>
                                <Button
                                    onClick={event => {
                                        event.stopPropagation();
                                        onClose();
                                    }}
                                    type="button"
                                    variant="secondary"
                                >
                                    Cancel
                                </Button>
                            </>
                        ) : null}
                        {isResult ? (
                            <Button
                                onClick={event => {
                                    event.stopPropagation();
                                    onClose();
                                }}
                                type="button"
                                variant="secondary"
                            >
                                Close
                            </Button>
                        ) : null}
                    </div>
                )
            }
            onOpenChange={handleOpenChange}
            open={open}
            showCloseButton={!isLoading}
            size="sm"
            title={titleByStep(step, result)}
        >
            {isLoading ? (
                <div className={styles.loading}>
                    <Progress
                        aria-label="Deleting customer data"
                        fullWidth
                        indeterminate
                    />
                </div>
            ) : null}
            {isResult && result ? (
                <Callout
                    variant={result.success ? "success" : "error"}
                    width="full"
                >
                    <CcpaDeleteSummary result={result} />
                </Callout>
            ) : null}
        </Modal>
    );
};

export default CcpaDeleteModal;
